export default [{
    path: 'product',
    name: {list:['业务中心','配置','类目配置','平台产品']},
    component: () => import('@/views/goods/product.vue')
},
{
    path: 'category',
    name: {list:['业务中心','配置','类目配置','平台品类']},
    component: () => import('@/views/goods/category.vue')
},{
    path: 'logistics',
    name: {list:['业务中心','配置','物流配置','物流公司']},
    component: () => import('@/views/goods/logisticsSet.vue')
},
{
    path: 'cropBreed',
    name: {list:['数字种植','配置','类目配置','作物品种']},
    component: () => import('@/views/goods/cropBreed.vue')
},
{
    path: 'cropCategory',
    name: {list:['数字种植','配置','类目配置','作物品类']},
    component: () => import('@/views/goods/cropCategory.vue')
},
{
    path: 'agricultureCategory',
    name: {list:['数字种植','配置','类目配置','农事类型']},
    component: () => import('@/views/goods/agricultureCategory.vue')
}
]